import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
// import { useHistory } from 'react-router';
import * as Yup from 'yup';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
// import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
// import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import axios from 'axios';
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

// import ButtonComp from '../../../components/button/index';
import ConfirmDialog from '../../../components/table/confirmDialog';
import FormDialog from '../../../components/table/FormDialog';
import { getBankDetailsRequest } from './store/actions/index';
import { CommonConfig } from '../../../config/common-config';
import './indexStyle.css';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';
import { TextField } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
// import DeleteIcon from '@material-ui/icons/Delete';
// import Dialog from '@material-ui/core/Dialog';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
import EditIcon from '@material-ui/icons/Edit';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        textAlign: 'center',
        fontSize: '25px',
        color: '#505050',
        margin: '50px',
    },
    bottom: {
        marginBottom: '1.35em',
    },
    paper: {
        margin: theme.spacing(1),
        boxShadow: 'none',
    },
    button: {
        textTransform: 'capitalize',
        padding: '8px 40px !important',
        letterSpacing: 'normal',
        background: '#3f51b5 !important',
        color: '#fff !important',
        borderRadius: '6px !important',
        border: 'none !important',
        cursor: 'pointer',
    },
    btnspace: {
        width: '100%',
    },
    disableBtn: {
        color: '#bbb !important',
        background: '#cecece !important',
        padding: '8px 40px !important',
        fontFamily: 'Rubik',
        textTransform: 'none !important',
        pointerEvents: 'none',
        borderRadius: '6px !important',
        border: 'none !important',
    },
    popTitle: {
        '& h2': {
            fontFamily: 'Rubik',
            fontSize: '18px',
            color: '#444',
        },
    },
    popContent: {
        fontFamily: 'Rubik',
        color: '#444',
    },
    popFoot: {
        fontFamily: 'Rubik',
        display: 'initial',
        paddingBottom: '20px',
        '& button': {
            marginLeft: '16px !important',
        },
    },
    remarks: {
        fontSize: '1rem',
        borderBottom: '1px solid #ccc',
    },
    btnBluepop: {
        fontSize: '14px !important',
        fontWeight: '400 !important',
        borderRadius: '6px',
        textTransform: 'capitalize',
        padding: '4px 20px',
        letterSpacing: 'normal',
        fontFamily: 'Rubik',
        background: '#3f51b5 !important',
        color: 'white',
    },
}));

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function BankClients(row) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const [showLoader, setShowLoader] = useState(false);
    const getbankdetails = useSelector((state) => state.bankdetailsreducer.getbankdetails);
    // const [addedBankdetailsMsg, setAddedBankdetailsMsg] = useState('');
    // const [updateStat, setUpdateStat] = useState(false);
    // const [deleteStat, setDeleteStat] = useState(false);
    // const [openBox, setOpenBox] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [deletepop, setDeletePop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const deletebankdetails = useSelector((state) => state.bankdetailsreducer.deletebankdetails);

    const [errorMessage, setErrorMessage] = useState('');
    const [rows, setTotalReactPackages] = useState([]);
    const [AllImcs, setAllImcs] = useState([getbankdetails]);
    // const vertical = 'top';
    // const horizontal = 'center';

    // For Implementating JWT-Token
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;

    const [declarationValue, setDeclarationValue] = useState('');
    const [declarationList, setDeclarationList] = useState('');
    const [editView, setEditView] = useState(false);
    // const [deleteEmpConfirm, setDeletEmpConfirm] = useState(false);
    // const [selectedImc, setselectedImc] = useState('');

    const formik = useFormik({
        initialValues: {
            accountholdername: '',
            accountnumber: '',
            bankname: '',
            branch: '',
            ifsccode: '',
        },
        validationSchema: Yup.object().shape({
            accountholdername: Yup.string()
                // .matches(/^[A-Z]{1}[A-Za-z ]+$/, 'Please Enter Valid AccountName')
                .required('Required Field'),
            bankname: Yup.string()
                .matches(/^[aA-zZ ]+$/, 'Enter Valid Bank Name')
                .required('Required Field'),
            branch: Yup.string()
                // .matches(/^[aA-zZ ]+$/, 'Enter Valid Branch Name')
                .required('Required Field'),
            accountnumber: Yup.string()
                .matches(/^\d{9,18}$/, 'Enter Valid Account Number')
                .required('Account Number is Mandatory'),
            ifsccode: Yup.string()
                .matches(/^[aA-zZ]{4}[0][0-9zaA-zZ]{6}$/, 'Enter Valid IFSC Code')
                .required('Enter IFSC code'),
        }),
        onSubmit: (values) => {
            setShowLoader(true);
            const data = {
                accountholderName: values.accountholdername,
                accountNumber: values.accountnumber,
                bankName: values.bankname,
                branch: values.branch,
                ifscCode: values.ifsccode,
                isDefault: false,
                createdBy: 'SUPERADMIN',
            };
            //console.log("data", data);
            // dispatch(createBankDetailsRequest({ params: data }));
            // setTimeout(() => {
            //     setShowBtnLoader(false);
            //     const err = errorMsg;
            //     ////console.log("ravi", errorMsg);
            //     if (errorMsg.data) {
            //         const err = errorMsg.data.message;
            //         ////console.log("if loop");
            //         setErrorMessage(err)
            //         setOpenBox(false)

            //     }
            //     else {
            //         ////console.log("else loop");
            //         setAddedBankdetailsMsg('Bank details added successfully')
            //         setOpenBox(true)
            //     }
            //     formik.resetForm({ values: '' });
            // }, 3000);

            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/s-bankdetails`, data, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    setShowLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        setSuccessPop(false);
                    }, 3000);
                    setTotalReactPackages(response.data);
                    setErrorMessage('');
                    formik.resetForm({ values: '' });
                })
                .catch((error) => {
                    //console.log('error', error.response.data);
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                        // formik.resetForm({ values: '' });
                    }
                });
        },
    });

    // const handleChange = (e, customerDetails, index) => {
    //     ////console.log(customerDetails, " Onchange Customer Details");
    //     ////console.log(e.target.value, "Target Value")
    //     // setbankDetails(customerDetails);
    //     // setradioChecked(index);
    // };

    // const handleClickOpen = (details) => {
    //     ////console.log(details, 'Target Value');
    // };

    const handleClose = () => {
        setShowLoader(false);
    };

    const handleSubmitDeclaration = () => {
        //console.log('declaraion', declarationValue)
        let temp = {
            declaration: declarationValue,
            // ,
            // declarationId: 1
        };
        //console.log('aaaa', temp)
        if (editView && declarationList) {
            //console.log('update');
            setShowLoader(true);
            axios
                .put(`${CommonConfig.dev.baseUrl}/api/auth/declaration-sa/1`, temp, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    if (response) {
                        setDeclarationList(declarationValue);
                        setEditView(false);
                        setTimeout(() => {
                            setShowLoader(false);
                        }, 1500);
                    }
                })
                .catch((error) => {
                    //console.log('error', error.response.data);
                    const errResult = error.response;
                    if (error && error.response && error.response.data) {
                        setTimeout(() => {
                            setShowLoader(false);
                        }, 1500);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setShowLoader(true);
                    }
                });
        } else {
            //console.log('create');
            setShowLoader(true);
            axios
                .post(`${CommonConfig.dev.baseUrl}/api/auth/declaration-sa`, temp, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    //console.log('response', response)
                    if (response) {
                        setDeclarationList(declarationValue);
                        setEditView(false);
                        setTimeout(() => {
                            setShowLoader(false);
                        }, 1500);
                    }
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (error && error.response && error.response.data) {
                        setTimeout(() => {
                            setShowLoader(false);
                        }, 1500);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setShowLoader(true);
                    }
                });
        }
    };

    // const handleDeleteDeclaration = () => {
    //     //console.log('delete declaration')
    //     setDeclarationValue('');
    //     setDeclarationList('');
    // };

    // const allImcsOptions = (vv) => {
    //     const OptionList = vv.map((data) => <option value={data.dbName}>{data.dbName}</option>);
    //     return OptionList;
    // };

    // const setImc = (e) => {
    //     setselectedImc(e.target.value);
    //     axios
    //         .get(`http://172.16.238.236:5020/api/auth/intClient-employee/${e.target.value}?page=0&size=100&sort=empId,desc`)
    //         .then((response) => {
    //             setTotalReactPackages(response.data.content);
    //             //console.log(response.data.content);
    //         })
    //         .catch((error) => {
    //             //console.log(error.response.data);
    //             if (error.response.data) {
    //                 setTotalReactPackages([]);
    //             }
    //         });
    // };

    const handleDelete = (details) => {
        setShowLoader(true);
        if (details.id) {
            // dispatch(deleteBankDetailsRequest({ params: details }));
            // setDeleteMsg('Record successfully deleted');
            // setUpdateStat(true);

            axios
                .delete(`${CommonConfig.dev.baseUrl}/api/auth/s-bankdetails/${details.id}`, {
                    headers: {
                        Authorization: bearerToken,
                    },
                })
                .then((response) => {
                    setShowLoader(false);
                    setDeletePop(true);
                    setTimeout(() => {
                        setDeletePop(false);
                    }, 3000);
                    setTotalReactPackages(response.data);
                })
                .catch((error) => {
                    const errResult = error.response;
                    if (errResult.data) {
                        setShowLoader(false);
                        setErrorPop(true);
                        setTimeout(() => {
                            setErrorPop(false);
                        }, 5000);
                        setErrorMsgGenerateRecceipt(errResult.data.message);
                    }
                });
        }
    };
    const [errormsg, setErrormsg] = useState('');

    useEffect(() => {
        dispatch(getBankDetailsRequest({ params: bearerToken }));
        window.scrollTo(0, 0);

        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/declaration-sa`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setEditView(true);
                if (response && response.data)
                    //console.log('response', response.data[0].declaration);
                    setDeclarationList(response.data[0].declaration);
                setDeclarationValue(response.data[0].declaration);
                setEditView(false);
            })
            .catch(() => { });

    }, [rows, deletebankdetails, AllImcs, userToken]);
    const toInputUppercase = (e) => {
        e.target.value = ('' + e.target.value).toUpperCase();
    };

    return (
        <>
            {/* <Snackbar open={openBox} anchorOrigin={{ vertical, horizontal }} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success">
                    {addedBankdetailsMsg}
                </Alert>
            </Snackbar>
            <Snackbar
                className="deleteError"
                open={updateStat}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={3000}
                onClose={() => {
                    setUpdateStat(false);
                }}
            >
                <Alert
                    onClose={() => {
                        setUpdateStat(false);
                    }}
                >
                    Bank Details deleted successfully
                </Alert>
            </Snackbar> */}

            {successpop ? (
                <SuccessPopUp
                    open={successpop}
                    showSuccess={successpop}
                    handleClose={handleClose}
                    title="Bank Details added successfully"
                />
            ) : null}
            {errorpop ? (
                <ErrorPopUp open={errorpop} showError={errorpop} handleClose={handleClose} title={errorMsgGenerateRecceipt} />
            ) : null}
            {deletepop ? (
                <SuccessPopUp
                    open={deletepop}
                    showSuccess={deletepop}
                    handleClose={handleClose}
                    title="Bank Details deleted successfully"
                />
            ) : null}

            <form onSubmit={formik.handleSubmit}>
                <Card className="clientcard">
                    <CardContent className="client-heading">
                        <Typography variant="h5">Bank Details</Typography>
                    </CardContent>

                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                        Account holder name
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Account holder name"
                                        className="bottom"
                                        name="accountholdername"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.accountholdername}
                                    />
                                    {formik.touched.accountholdername && formik.errors.accountholdername ? (
                                        <span className="itec-validationError">{formik.errors.accountholdername}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                        Account number
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Account number"
                                        className="bottom"
                                        name="accountnumber"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.accountnumber}
                                    />
                                    {formik.touched.accountnumber && formik.errors.accountnumber ? (
                                        <span className="itec-validationError">{formik.errors.accountnumber}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                        Bank name
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Bank name"
                                        className="bottom"
                                        name="bankname"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.bankname}
                                    />
                                    {formik.touched.bankname && formik.errors.bankname ? (
                                        <span className="itec-validationError">{formik.errors.bankname}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                        Branch
                                    </InputLabel>
                                    <Input
                                        type="text"
                                        placeholder="Branch"
                                        className="bottom"
                                        name="branch"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.branch}
                                    />
                                    {formik.touched.branch && formik.errors.branch ? (
                                        <span className="itec-validationError">{formik.errors.branch}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                        IFSC Code
                                    </InputLabel>
                                    <Input
                                        onInput={toInputUppercase}
                                        type="text"
                                        placeholder="IFSC Code"
                                        className="bottom txtTransform"
                                        name="ifsccode"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.ifsccode}
                                    />
                                    {formik.touched.ifsccode && formik.errors.ifsccode ? (
                                        <span className="itec-validationError">{formik.errors.ifsccode}</span>
                                    ) : null}
                                </FormControl>
                            </Grid>

                            {/* <div className="bankbtnmaindiv">
                        <div> {errorMessage}</div>
                        <div className="bankbtndiv">
                            {(showBtnLoader && (
                                <Button variant="outlined" className="butn btnOrange" disabled>
                                    <CircularProgress style={{ color: '#F8951B' }} size={20} />
                                </Button>
                            )) || <ButtonComp type="submit" className="butn" title="Add Bank" />}
                        </div>
                    </div> */}
                            <div className="errorMsgRed">{errormsg}</div>
                            <div className="createintermediary-btndiv">
                                {/* {(showLoader && (
                                    <Button variant="outlined" className="butn butnImp" disabled>
                                        <CircularProgress size={20} />
                                    </Button>
                                )) || <ButtonComp type="submit" className="intermediarybutn" title="Add Bank" />} */}

                                {(showLoader ? (
                                    <LoaderPopUp
                                        showLoader={showLoader}
                                        handleClose={handleClose}
                                        title="Please wait while we updating your Bank Details"
                                    />
                                ) : null) || (
                                        <Button variant="outlined" color="primary" type="submit" className={classes.button} title="Add Bank">
                                            Add Bank
                                    </Button>
                                    )}
                            </div>
                        </Grid>
                    </CardContent>
                </Card>
            </form>
            <div style={{ paddingTop: '20px' }}>
                <Card className="clientcard">
                    <CardContent className="client-heading" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant="h5">Declaration for Invoice generation</Typography>
                        <div>
                            {/* <div className={classes.heading5}>Declaration for Invoice generation</div> */}
                            <div>
                                <Tooltip title="Edit" onClick={() => setEditView(true)}>
                                    <IconButton aria-label="Edit" style={{ padding: '0px' }}>
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        </div>
                    </CardContent>

                    <CardContent>
                        <Grid container spacing={3} className="main-container">
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <InputLabel className="lbl" htmlFor="tennantName" shrink>
                                        Declaration
                                    </InputLabel>
                                    <TextField
                                        type="text"
                                        placeholder="Enter the Declaration"
                                        className="bottom marginTop"
                                        name="declaration"
                                        multiline
                                        rows={4}
                                        onChange={(e) => setDeclarationValue(e.target.value)}
                                        // onBlur={formik.handleBlur}
                                        value={declarationValue}
                                        disabled={!editView}
                                    />
                                    {/* {formik.touched.ifsccode && formik.errors.ifsccode ? (
                                    <span className="itec-validationError">{formik.errors.ifsccode}</span>
                                ) : null} */}
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <div style={{ marginTop: '15px' }}>
                    {editView ? (
                        <Button
                            variant="outlined"
                            color="primary"
                            className={!declarationValue ? classes.disableBtn : classes.button}
                            onClick={handleSubmitDeclaration}
                        >
                            Save
                        </Button>
                    ) : (
                            <Button
                                variant="outlined"
                                color="primary"
                                className={declarationValue && declarationList ? classes.disableBtn : classes.button}
                                onClick={handleSubmitDeclaration}
                            >
                                Save
                        </Button>
                        )}
                </div>
            </div>

            {/* <Card className="clientcard"> */}
            <Grid container spacing={4} direction="row" className="cardmainDiv">
                {getbankdetails &&
                    getbankdetails.map((details, index) => {
                        return (
                            <Grid item xs={12} sm={4} key={details.id} className="">
                                <Card className="cardHeight">
                                    <CardContent className="holder">
                                        <div className="cardheader-maindiv">
                                            <span style={{ display: 'inline-grid' }}>
                                                {details.isDefault ? (
                                                    <div className="cardheader-leftdiv">
                                                        <span style={{ fontWeight: '600' }}>Fees account</span>
                                                    </div>
                                                ) : (
                                                        ''
                                                    )}
                                                {/* {details.isSettax ? (
                                                    <div className="cardheader-leftdiv">
                                                        <span style={{ fontWeight: '600' }}>Client Tax transfer account</span>
                                                    </div>
                                                ) : (
                                                    ''
                                                )} */}
                                            </span>

                                            <div className="bankDetailsIcon">
                                                <FormDialog row={details} pageName="bankclientsedit" show="editIcon" />
                                                {details.isDefault === true ? '' : <ConfirmDialog row={details} deleteRow={handleDelete} />}
                                            </div>
                                        </div>
                                        <Typography variant="body2" className="marginBottom">
                                            {/* Account holder Name: <span className="bankDetailstxt">{details.accountholderName}</span> */}
                                            <span className="bankDetailstxt">
                                                <h3>{details.accountholderName}</h3>
                                            </span>
                                        </Typography>
                                        <Typography variant="body2" className="marginBottom">
                                            {/* Account Number: <span className="bankDetailstxt">{details.accountNumber}</span> */}
                                            <span className="bankDetailstxt">{details.accountNumber}</span>
                                        </Typography>
                                        <Typography variant="body2" className="marginBottom">
                                            IFSC-Code: <span className="bankDetailstxt">{details.ifscCode}</span>
                                        </Typography>
                                        <Typography variant="body2" className="marginBottom">
                                            Bank Name: <span className="bankDetailstxt">{details.bankName}</span>
                                        </Typography>
                                        <Typography variant="body2" className="marginBottom">
                                            Branch: <span className="bankDetailstxt">{details.branch}</span>
                                        </Typography>
                                        {/* {details.isSettax ?
                                            <Typography variant="body2" className="marginBottom">
                                                Tax Payment Account: <span className="bankDetailstxt">{details.isSettax ? 'True' : 'False'}</span>
                                            </Typography> : null} */}
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
            </Grid>
            {/* {declarationList ?
                <Grid container spacing={4} direction="row" className="cardmainDiv">
                    <Grid className="marginRight15">
                        <Card className="cardHeight" style={{ minHeight: '116px' }}>
                            <CardContent className="holder">
                                <div className="cardheader-maindiv">
                                    <div className="bankDetailsIcon">
                                        <FormDialog
                                            row={{ declarationtype: 'Declaration', declarationvalue: declarationList }}
                                            editpageName={selectedImc}
                                            pageName="bankclientsedit"
                                            show="editIcon"
                                        />

                                        <Tooltip title="Delete">
                                            <IconButton aria-label="delete" onClick={() => setDeletEmpConfirm(true)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Tooltip>

                                    </div>
                                </div>
                                <Typography variant="body2" className="marginBottom">
                                    Declaration: <span className="bankDetailstxt" style={{ whiteSpace: 'break-spaces' }}>{declarationList}</span>
                                </Typography>
                            </CardContent>
                        </Card>
                        <Dialog
                            open={deleteEmpConfirm}
                            onClose={() => setDeletEmpConfirm(false)}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                            style={{ fontFamily: 'Rubik' }}
                        >
                            <DialogTitle className={classes.popTitle} id="alert-dialog-title">
                                Please confirm
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description" className={classes.popContent}>
                                    Are you sure you want to delete this record? If yes, press Ok or press Cancel to go back.
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions className={classes.popFoot}>
                                <Button onClick={() => setDeletEmpConfirm(false)} variant="outlined" color="primary" size="small" className={classes.btnBluepop} autoFocus>
                                    Cancel
                                </Button>
                                <Button onClick={() => handleDeleteDeclaration()} variant="outlined" color="primary" size="small" className={classes.btnBluepop}>
                                    Ok
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Grid>
                </Grid> : null} */}
        </>
    );
}

export default BankClients;
